import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminHeader } from '../../../shared/components';
import { RoleProtectedRoute } from '../../../shared/components';
import ConfigList from './ConfigList';

/**
 * Componente principal de gestión de configuraciones del sistema
 * Mantiene el header de navegación consistente con AdminDashboard
 */
const ConfigManagement = ({ adminData, onLogout }) => {
  const navigate = useNavigate();

  // Manejar volver al dashboard
  const handleBackToDashboard = () => {
    navigate('/admin');
  };

  return (
    <RoleProtectedRoute requiredRole="admin">
      <div className="min-h-screen bg-gray-50">
        {/* Header consistente */}
        <AdminHeader
          adminData={adminData}
          onLogout={onLogout}
          showBackButton={true}
          onBackClick={handleBackToDashboard}
          backButtonText="Volver al Dashboard"
        />

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Contenido principal */}
          <ConfigList />
        </main>
      </div>
    </RoleProtectedRoute>
  );
};

export default ConfigManagement; 